import Rails from "@rails/ujs"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["entries", "pagination"]

  scroll() {
    const paginationElement = this.paginationTarget.querySelector(".pagination")
    if (!paginationElement) { return }

    let paginationList = paginationElement.children
    if (!paginationList || paginationList.length === 0) { return }

    let url = paginationList[paginationList.length - 1].querySelector("a")
    if (url == null ) { return }

    url = url.href

    const body = document.body, html = document.documentElement
    const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)

    if (window.pageYOffset >= height - window.innerHeight) {
      this.loadMore(url)
    }
  }

  loadMore(url) {
    Rails.ajax({
      type: "GET",
      url: url,
      dataType: "json",
      success: (data) => {
        this.entriesTarget.insertAdjacentHTML("beforeend", data.entries)
        this.paginationTarget.innerHTML = data.pagination
      }
    })
  }
}
